import { render, staticRenderFns } from "./atom.tabUpcharge.vue?vue&type=template&id=d77fc0a0"
import script from "./atom.tabUpcharge.vue?vue&type=script&lang=ts"
export * from "./atom.tabUpcharge.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports